export * as Api from './api';

export enum UserType {
  Organisation = 0,
  Adviser = 1,
  Investor = 2,
}
